import { SVGProps } from "react";

export const Icon = ({
  svg,
  width = 20,
  height = 20,
  className = "",
  ...props
}: {
  svg?: string;
  width?: number;
  height?: number;
  className?: string;
} & SVGProps<SVGSVGElement>) => {
  return (
    <svg
      className={`${className} min-w-fit`}
      width={width ? width : 20}
      height={height ? height : 20}
      {...props}
    >
      <use href={`/assets/images/icons_sprite.svg#${svg}`}></use>
    </svg>
  );
};
